// https://support.coingate.com/en/47/how-can-i-test-your-service-sandbox-testing
import React, { ReactElement } from 'react'
import { Spinner } from '@theme-ui/components'
import { Button } from 'ui/Buttons'
import { useAppSelector, useAppDispatch } from 'store/hooks'
import { startTransaction, TransactionStatus } from 'store/billing'
import { Text } from 'theme-ui'
import { defaultCurrencyCode } from 'store/api/billing'
import { useCreateCoingateOrderMutation } from 'store/api/billing/payments'

const ContinueToCoingateButton = ({ pricePK }: { pricePK: string }): ReactElement => {
  const dispatch = useAppDispatch()
  const { promoMode, promoCode } = useAppSelector(s => s.products)
  const transactionStatus = useAppSelector(s => s.payments.transactionStatus)
  const sessionToken = useAppSelector(s => s.persistData.sessionToken)
  const selectedCurrency = useAppSelector(s => s.products.selectedCurrency)
  const [submitCryptoPayment] = useCreateCoingateOrderMutation()

  return (
    <Button
      disabled={!sessionToken}
      data-testid="create-coingate-order"
      ariaLabel="create coingate order"
      variant="gradientButton"
      sx={{
        minWidth: '100%',
        height: '4.7rem',
      }}
      onClick={async (): Promise<void> => {
        dispatch(startTransaction())
        await submitCryptoPayment({
          price_point_id: pricePK,
          currency: selectedCurrency?.code ?? defaultCurrencyCode,
          ...(promoMode && promoCode
            ? {
                [promoMode]: promoCode,
              }
            : {}),
        })
      }}
    >
      {transactionStatus === TransactionStatus.INPROGRESS ? (
        <Spinner
          color="black"
          sx={{
            height: '1.8rem',
          }}
        />
      ) : (
        <>
          <Text variant="size17Weight500Line138" sx={{}}>
            Continue To Coingate
          </Text>
        </>
      )}
    </Button>
  )
}

export default React.memo(ContinueToCoingateButton)
